import request from '@/utils/request'

let ContractApi = {
  /*合同列表*/
  contractlist(data, errorback) {
    return request._post('/shop/plus.contract.contract/index', data, errorback);
  },
  /*添加合同*/
  addContract(data, errorback) {
    return request._post('/shop/plus.contract.contract/add', data, errorback);
  },
  /*获取数据*/
  getData(data, errorback) {
    return request._get('/shop/plus.contract.contract/add', data, errorback);
  },
  /*合同详情*/
  toEditContract(data, errorback) {
    return request._get('/shop/plus.contract.contract/edit', data, errorback);
  },
  /*编辑合同*/
  editContract(data, errorback) {
    return request._post('/shop/plus.contract.contract/edit', data, errorback);
  },
  /*删除合同*/
  deleteContract(data, errorback) {
    return request._post('/shop/plus.contract.contract/del', data, errorback);
  },
}
export default ContractApi;



// WEBPACK FOOTER //
// ./src/api/plus/contract.js